import { gql, useLazyQuery } from '@apollo/client';
import { useEffect, useState } from 'react';
import { RecordState } from 'src/common/string-enum';
import { ErrorMessage } from 'src/enum/messsage-enum';
import { getMstUser } from 'src/graphql/queries';

interface MstUser {
  mu_mail: string;
  mu_user_id: number | null;
  mu_user_nm: string;
  mu_office_cd: number | null;
  mu_admin_kb: number | null;
  recordState: RecordState;
}

const ListRegisterSample = () => {
  const [userList, setUserList] = useState<MstUser[]>([]);

  const [searchMstUser, { data: mstUserData }] = useLazyQuery(gql(getMstUser), {
    fetchPolicy: 'network-only',
    onError: (error) => {
      // Timeoutの場合はaurora側の起動時間Issueととらえ、リトライする
      if (error?.message === ErrorMessage.GRAPH_QL_TIME_OUT) {
        searchMstUser({ variables: { input: undefined } });
      } else {
        window.alert('Searching mst_user error');
      }
    },
  });

  useEffect(() => {
    searchMstUser({ variables: { input: undefined } });
  }, []);

  useEffect(() => {
    if (mstUserData) {
      const target: MstUser[] = [];
      mstUserData.getMstUser.forEach((user: any) => {
        target.push({ ...user, ...{ recordState: RecordState.NONE } });
      });
      target.push({
        mu_mail: '',
        mu_user_id: null,
        mu_user_nm: '',
        mu_office_cd: null,
        mu_admin_kb: null,
        recordState: RecordState.INSERT,
      });
      setUserList(target);
    }
  }, [mstUserData]);

  const handleRegister = () => {
    userList.forEach((user) => {
      switch (user.recordState) {
        case RecordState.DELETE:
          if (!user.mu_mail) {
            console.log('validation error', user);
            return;
          }
          console.log('execute delete', user);
          break;
        case RecordState.INSERT:
          if (!user.mu_mail && !user.mu_user_nm) return;
          console.log('execute insert', user);
          break;
        case RecordState.UPDATE:
          if (!user.mu_mail) {
            console.log('validation error', user);
            return;
          }
          console.log('execute update', user);
          break;
        default:
          console.log('do nothing', user);
      }
    });
  };

  const handleUpdate = (index: number, user: any, key: string, value: any) => {
    setUserList((prevState) => [
      ...prevState.slice(0, index),
      ...[
        {
          ...user,
          ...{
            [key]: value,
            recordState: user.recordState === RecordState.INSERT ? RecordState.INSERT : RecordState.UPDATE,
          },
        },
      ],
      ...prevState.slice(index + 1),
    ]);
  };

  const handleDelete = (index: number, user: any) => {
    setUserList((prevState) => [
      ...prevState.slice(0, index),
      ...(user.recordState !== RecordState.INSERT ? [{ ...user, ...{ recordState: RecordState.DELETE } }] : []),
      ...prevState.slice(index + 1),
    ]);
  };

  const addNewLine = (index: number) => {
    if (userList.length - 1 === index) {
      const newLine: MstUser = {
        mu_mail: '',
        mu_user_id: null,
        mu_user_nm: '',
        mu_office_cd: null,
        mu_admin_kb: null,
        recordState: RecordState.INSERT,
      };
      setUserList((prevState) => [...prevState, ...[newLine]]);
    }
  };

  return (
    <div className="flex justify-center">
      <div>
        <button onClick={handleRegister}>登録</button>
        <ul>
          {userList.map(
            (user: any, index: number) =>
              user.recordState !== RecordState.DELETE && (
                <li key={index}>
                  <div className="flex ">
                    <div>{index}</div>
                    <input
                      className="border border-black w-48"
                      value={user.mu_mail}
                      onChange={(e) => {
                        handleUpdate(index, user, 'mu_mail', e.target.value);
                      }}
                      onClick={() => addNewLine(index)}
                    />
                    <input
                      className="border border-black w-32"
                      value={user.mu_user_nm}
                      onChange={(e) => {
                        handleUpdate(index, user, 'mu_user_nm', e.target.value);
                      }}
                      onClick={() => addNewLine(index)}
                    />
                    <button
                      onClick={() => {
                        console.log(index);
                        console.log(user);
                        return (
                          (user.recordState !== RecordState.INSERT ||
                            (index !== 0 &&
                              user.recordState === RecordState.INSERT &&
                              userList[index - 1].recordState === RecordState.INSERT)) &&
                          handleDelete(index, user)
                        );
                      }}
                    >
                      削除
                    </button>
                  </div>
                </li>
              )
          )}
        </ul>
      </div>
    </div>
  );
};

export default ListRegisterSample;
